/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AllocationBody } from '../models';
// @ts-ignore
import type { AllocationResponse } from '../models';
// @ts-ignore
import type { DefaultIntroOfferBody } from '../models';
// @ts-ignore
import type { DefaultIntroOfferResponse } from '../models';
// @ts-ignore
import type { EmptySuccess } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ExperimentListResponse } from '../models';
// @ts-ignore
import type { ExperimentStatsResponse } from '../models';
// @ts-ignore
import type { ExposureBody } from '../models';
// @ts-ignore
import type { FunnelEventBody } from '../models';
// @ts-ignore
import type { IntroDealPricesBody } from '../models';
// @ts-ignore
import type { IntroDealSettings } from '../models';
// @ts-ignore
import type { IntroOffersBody } from '../models';
// @ts-ignore
import type { IntroOffersResponse } from '../models';
// @ts-ignore
import type { KillSwitchBody } from '../models';
// @ts-ignore
import type { KillSwitchResponse } from '../models';
// @ts-ignore
import type { MyExperimentsResponse } from '../models';
// @ts-ignore
import type { ResolveBody } from '../models';
// @ts-ignore
import type { ResolveResponse } from '../models';
// @ts-ignore
import type { StatusBody } from '../models';
// @ts-ignore
import type { StatusResponse } from '../models';
// @ts-ignore
import type { UserArmBody } from '../models';
// @ts-ignore
import type { UserArmResponse } from '../models';
// @ts-ignore
import type { WeightsBody } from '../models';
// @ts-ignore
import type { WeightsResponse } from '../models';
/**
 * ExperimentApiApi - axios parameter creator
 */
export const ExperimentApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} experimentKey 
         * @param {ExperimentApiAdminExperimentStatsDaysEnum} [days] 
         * @param {ExperimentApiAdminExperimentStatsIntroOfferEnum} [introOffer] 
         * @param {string | null} [splitBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminExperimentStats: async (experimentKey: string, days?: ExperimentApiAdminExperimentStatsDaysEnum, introOffer?: ExperimentApiAdminExperimentStatsIntroOfferEnum, splitBy?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'experimentKey' is not null or undefined
            assertParamExists('experimentApiAdminExperimentStats', 'experimentKey', experimentKey)
            const localVarPath = `/admin/experiment/{experiment_key}/stats`
                .replace('{experiment_key}', encodeURIComponent(String(experimentKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (introOffer !== undefined) {
                localVarQueryParameter['intro_offer'] = introOffer;
            }

            if (splitBy !== undefined) {
                localVarQueryParameter['split_by'] = splitBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminListExperiments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/experiment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DefaultIntroOfferBody} defaultIntroOfferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetDefaultIntroOffer: async (defaultIntroOfferBody: DefaultIntroOfferBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'defaultIntroOfferBody' is not null or undefined
            assertParamExists('experimentApiAdminSetDefaultIntroOffer', 'defaultIntroOfferBody', defaultIntroOfferBody)
            const localVarPath = `/admin/experiment/default-intro-offer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(defaultIntroOfferBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} experimentKey 
         * @param {AllocationBody} allocationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetExperimentAllocation: async (experimentKey: string, allocationBody: AllocationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'experimentKey' is not null or undefined
            assertParamExists('experimentApiAdminSetExperimentAllocation', 'experimentKey', experimentKey)
            // verify required parameter 'allocationBody' is not null or undefined
            assertParamExists('experimentApiAdminSetExperimentAllocation', 'allocationBody', allocationBody)
            const localVarPath = `/admin/experiment/{experiment_key}/allocation`
                .replace('{experiment_key}', encodeURIComponent(String(experimentKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(allocationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} experimentKey 
         * @param {StatusBody} statusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetExperimentStatus: async (experimentKey: string, statusBody: StatusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'experimentKey' is not null or undefined
            assertParamExists('experimentApiAdminSetExperimentStatus', 'experimentKey', experimentKey)
            // verify required parameter 'statusBody' is not null or undefined
            assertParamExists('experimentApiAdminSetExperimentStatus', 'statusBody', statusBody)
            const localVarPath = `/admin/experiment/{experiment_key}/status`
                .replace('{experiment_key}', encodeURIComponent(String(experimentKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} experimentKey 
         * @param {WeightsBody} weightsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetExperimentWeights: async (experimentKey: string, weightsBody: WeightsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'experimentKey' is not null or undefined
            assertParamExists('experimentApiAdminSetExperimentWeights', 'experimentKey', experimentKey)
            // verify required parameter 'weightsBody' is not null or undefined
            assertParamExists('experimentApiAdminSetExperimentWeights', 'weightsBody', weightsBody)
            const localVarPath = `/admin/experiment/{experiment_key}/weights`
                .replace('{experiment_key}', encodeURIComponent(String(experimentKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weightsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IntroDealPricesBody} introDealPricesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetIntroDealPrices: async (introDealPricesBody: IntroDealPricesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'introDealPricesBody' is not null or undefined
            assertParamExists('experimentApiAdminSetIntroDealPrices', 'introDealPricesBody', introDealPricesBody)
            const localVarPath = `/admin/experiment/intro-deal-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(introDealPricesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} experimentKey 
         * @param {IntroOffersBody} introOffersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetIntroOffers: async (experimentKey: string, introOffersBody: IntroOffersBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'experimentKey' is not null or undefined
            assertParamExists('experimentApiAdminSetIntroOffers', 'experimentKey', experimentKey)
            // verify required parameter 'introOffersBody' is not null or undefined
            assertParamExists('experimentApiAdminSetIntroOffers', 'introOffersBody', introOffersBody)
            const localVarPath = `/admin/experiment/{experiment_key}/intro-offers`
                .replace('{experiment_key}', encodeURIComponent(String(experimentKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(introOffersBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {KillSwitchBody} killSwitchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetKillSwitch: async (killSwitchBody: KillSwitchBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'killSwitchBody' is not null or undefined
            assertParamExists('experimentApiAdminSetKillSwitch', 'killSwitchBody', killSwitchBody)
            const localVarPath = `/admin/experiment/kill-switch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(killSwitchBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} experimentKey 
         * @param {UserArmBody} userArmBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetUserArm: async (experimentKey: string, userArmBody: UserArmBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'experimentKey' is not null or undefined
            assertParamExists('experimentApiAdminSetUserArm', 'experimentKey', experimentKey)
            // verify required parameter 'userArmBody' is not null or undefined
            assertParamExists('experimentApiAdminSetUserArm', 'userArmBody', userArmBody)
            const localVarPath = `/admin/experiment/{experiment_key}/user-arm`
                .replace('{experiment_key}', encodeURIComponent(String(experimentKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userArmBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExposureBody} exposureBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiLogExposure: async (exposureBody: ExposureBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exposureBody' is not null or undefined
            assertParamExists('experimentApiLogExposure', 'exposureBody', exposureBody)
            const localVarPath = `/experiment/exposure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exposureBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FunnelEventBody} funnelEventBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiLogFunnelEvent: async (funnelEventBody: FunnelEventBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'funnelEventBody' is not null or undefined
            assertParamExists('experimentApiLogFunnelEvent', 'funnelEventBody', funnelEventBody)
            const localVarPath = `/experiment/funnel-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(funnelEventBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiMyExperiments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/experiment/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResolveBody} resolveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiResolveExperiments: async (resolveBody: ResolveBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resolveBody' is not null or undefined
            assertParamExists('experimentApiResolveExperiments', 'resolveBody', resolveBody)
            const localVarPath = `/experiment/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExperimentApiApi - functional programming interface
 */
export const ExperimentApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExperimentApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} experimentKey 
         * @param {ExperimentApiAdminExperimentStatsDaysEnum} [days] 
         * @param {ExperimentApiAdminExperimentStatsIntroOfferEnum} [introOffer] 
         * @param {string | null} [splitBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiAdminExperimentStats(experimentKey: string, days?: ExperimentApiAdminExperimentStatsDaysEnum, introOffer?: ExperimentApiAdminExperimentStatsIntroOfferEnum, splitBy?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperimentStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiAdminExperimentStats(experimentKey, days, introOffer, splitBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiAdminExperimentStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiAdminListExperiments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperimentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiAdminListExperiments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiAdminListExperiments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DefaultIntroOfferBody} defaultIntroOfferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiAdminSetDefaultIntroOffer(defaultIntroOfferBody: DefaultIntroOfferBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultIntroOfferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiAdminSetDefaultIntroOffer(defaultIntroOfferBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiAdminSetDefaultIntroOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} experimentKey 
         * @param {AllocationBody} allocationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiAdminSetExperimentAllocation(experimentKey: string, allocationBody: AllocationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiAdminSetExperimentAllocation(experimentKey, allocationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiAdminSetExperimentAllocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} experimentKey 
         * @param {StatusBody} statusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiAdminSetExperimentStatus(experimentKey: string, statusBody: StatusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiAdminSetExperimentStatus(experimentKey, statusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiAdminSetExperimentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} experimentKey 
         * @param {WeightsBody} weightsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiAdminSetExperimentWeights(experimentKey: string, weightsBody: WeightsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiAdminSetExperimentWeights(experimentKey, weightsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiAdminSetExperimentWeights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IntroDealPricesBody} introDealPricesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiAdminSetIntroDealPrices(introDealPricesBody: IntroDealPricesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntroDealSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiAdminSetIntroDealPrices(introDealPricesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiAdminSetIntroDealPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} experimentKey 
         * @param {IntroOffersBody} introOffersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiAdminSetIntroOffers(experimentKey: string, introOffersBody: IntroOffersBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntroOffersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiAdminSetIntroOffers(experimentKey, introOffersBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiAdminSetIntroOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {KillSwitchBody} killSwitchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiAdminSetKillSwitch(killSwitchBody: KillSwitchBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KillSwitchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiAdminSetKillSwitch(killSwitchBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiAdminSetKillSwitch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} experimentKey 
         * @param {UserArmBody} userArmBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiAdminSetUserArm(experimentKey: string, userArmBody: UserArmBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserArmResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiAdminSetUserArm(experimentKey, userArmBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiAdminSetUserArm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExposureBody} exposureBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiLogExposure(exposureBody: ExposureBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptySuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiLogExposure(exposureBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiLogExposure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FunnelEventBody} funnelEventBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiLogFunnelEvent(funnelEventBody: FunnelEventBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmptySuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiLogFunnelEvent(funnelEventBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiLogFunnelEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiMyExperiments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyExperimentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiMyExperiments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiMyExperiments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResolveBody} resolveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async experimentApiResolveExperiments(resolveBody: ResolveBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResolveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.experimentApiResolveExperiments(resolveBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExperimentApiApi.experimentApiResolveExperiments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExperimentApiApi - factory interface
 */
export const ExperimentApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExperimentApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ExperimentApiApiExperimentApiAdminExperimentStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminExperimentStats(requestParameters: ExperimentApiApiExperimentApiAdminExperimentStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExperimentStatsResponse> {
            return localVarFp.experimentApiAdminExperimentStats(requestParameters.experimentKey, requestParameters.days, requestParameters.introOffer, requestParameters.splitBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminListExperiments(options?: RawAxiosRequestConfig): AxiosPromise<ExperimentListResponse> {
            return localVarFp.experimentApiAdminListExperiments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExperimentApiApiExperimentApiAdminSetDefaultIntroOfferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetDefaultIntroOffer(requestParameters: ExperimentApiApiExperimentApiAdminSetDefaultIntroOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<DefaultIntroOfferResponse> {
            return localVarFp.experimentApiAdminSetDefaultIntroOffer(requestParameters.defaultIntroOfferBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExperimentApiApiExperimentApiAdminSetExperimentAllocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetExperimentAllocation(requestParameters: ExperimentApiApiExperimentApiAdminSetExperimentAllocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AllocationResponse> {
            return localVarFp.experimentApiAdminSetExperimentAllocation(requestParameters.experimentKey, requestParameters.allocationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExperimentApiApiExperimentApiAdminSetExperimentStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetExperimentStatus(requestParameters: ExperimentApiApiExperimentApiAdminSetExperimentStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<StatusResponse> {
            return localVarFp.experimentApiAdminSetExperimentStatus(requestParameters.experimentKey, requestParameters.statusBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExperimentApiApiExperimentApiAdminSetExperimentWeightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetExperimentWeights(requestParameters: ExperimentApiApiExperimentApiAdminSetExperimentWeightsRequest, options?: RawAxiosRequestConfig): AxiosPromise<WeightsResponse> {
            return localVarFp.experimentApiAdminSetExperimentWeights(requestParameters.experimentKey, requestParameters.weightsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExperimentApiApiExperimentApiAdminSetIntroDealPricesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetIntroDealPrices(requestParameters: ExperimentApiApiExperimentApiAdminSetIntroDealPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntroDealSettings> {
            return localVarFp.experimentApiAdminSetIntroDealPrices(requestParameters.introDealPricesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExperimentApiApiExperimentApiAdminSetIntroOffersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetIntroOffers(requestParameters: ExperimentApiApiExperimentApiAdminSetIntroOffersRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntroOffersResponse> {
            return localVarFp.experimentApiAdminSetIntroOffers(requestParameters.experimentKey, requestParameters.introOffersBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExperimentApiApiExperimentApiAdminSetKillSwitchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetKillSwitch(requestParameters: ExperimentApiApiExperimentApiAdminSetKillSwitchRequest, options?: RawAxiosRequestConfig): AxiosPromise<KillSwitchResponse> {
            return localVarFp.experimentApiAdminSetKillSwitch(requestParameters.killSwitchBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExperimentApiApiExperimentApiAdminSetUserArmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiAdminSetUserArm(requestParameters: ExperimentApiApiExperimentApiAdminSetUserArmRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserArmResponse> {
            return localVarFp.experimentApiAdminSetUserArm(requestParameters.experimentKey, requestParameters.userArmBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExperimentApiApiExperimentApiLogExposureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiLogExposure(requestParameters: ExperimentApiApiExperimentApiLogExposureRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmptySuccess> {
            return localVarFp.experimentApiLogExposure(requestParameters.exposureBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExperimentApiApiExperimentApiLogFunnelEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiLogFunnelEvent(requestParameters: ExperimentApiApiExperimentApiLogFunnelEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmptySuccess> {
            return localVarFp.experimentApiLogFunnelEvent(requestParameters.funnelEventBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiMyExperiments(options?: RawAxiosRequestConfig): AxiosPromise<MyExperimentsResponse> {
            return localVarFp.experimentApiMyExperiments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExperimentApiApiExperimentApiResolveExperimentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        experimentApiResolveExperiments(requestParameters: ExperimentApiApiExperimentApiResolveExperimentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResolveResponse> {
            return localVarFp.experimentApiResolveExperiments(requestParameters.resolveBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for experimentApiAdminExperimentStats operation in ExperimentApiApi.
 */
export interface ExperimentApiApiExperimentApiAdminExperimentStatsRequest {
    readonly experimentKey: string

    readonly days?: ExperimentApiAdminExperimentStatsDaysEnum

    readonly introOffer?: ExperimentApiAdminExperimentStatsIntroOfferEnum

    readonly splitBy?: string | null
}

/**
 * Request parameters for experimentApiAdminSetDefaultIntroOffer operation in ExperimentApiApi.
 */
export interface ExperimentApiApiExperimentApiAdminSetDefaultIntroOfferRequest {
    readonly defaultIntroOfferBody: DefaultIntroOfferBody
}

/**
 * Request parameters for experimentApiAdminSetExperimentAllocation operation in ExperimentApiApi.
 */
export interface ExperimentApiApiExperimentApiAdminSetExperimentAllocationRequest {
    readonly experimentKey: string

    readonly allocationBody: AllocationBody
}

/**
 * Request parameters for experimentApiAdminSetExperimentStatus operation in ExperimentApiApi.
 */
export interface ExperimentApiApiExperimentApiAdminSetExperimentStatusRequest {
    readonly experimentKey: string

    readonly statusBody: StatusBody
}

/**
 * Request parameters for experimentApiAdminSetExperimentWeights operation in ExperimentApiApi.
 */
export interface ExperimentApiApiExperimentApiAdminSetExperimentWeightsRequest {
    readonly experimentKey: string

    readonly weightsBody: WeightsBody
}

/**
 * Request parameters for experimentApiAdminSetIntroDealPrices operation in ExperimentApiApi.
 */
export interface ExperimentApiApiExperimentApiAdminSetIntroDealPricesRequest {
    readonly introDealPricesBody: IntroDealPricesBody
}

/**
 * Request parameters for experimentApiAdminSetIntroOffers operation in ExperimentApiApi.
 */
export interface ExperimentApiApiExperimentApiAdminSetIntroOffersRequest {
    readonly experimentKey: string

    readonly introOffersBody: IntroOffersBody
}

/**
 * Request parameters for experimentApiAdminSetKillSwitch operation in ExperimentApiApi.
 */
export interface ExperimentApiApiExperimentApiAdminSetKillSwitchRequest {
    readonly killSwitchBody: KillSwitchBody
}

/**
 * Request parameters for experimentApiAdminSetUserArm operation in ExperimentApiApi.
 */
export interface ExperimentApiApiExperimentApiAdminSetUserArmRequest {
    readonly experimentKey: string

    readonly userArmBody: UserArmBody
}

/**
 * Request parameters for experimentApiLogExposure operation in ExperimentApiApi.
 */
export interface ExperimentApiApiExperimentApiLogExposureRequest {
    readonly exposureBody: ExposureBody
}

/**
 * Request parameters for experimentApiLogFunnelEvent operation in ExperimentApiApi.
 */
export interface ExperimentApiApiExperimentApiLogFunnelEventRequest {
    readonly funnelEventBody: FunnelEventBody
}

/**
 * Request parameters for experimentApiResolveExperiments operation in ExperimentApiApi.
 */
export interface ExperimentApiApiExperimentApiResolveExperimentsRequest {
    readonly resolveBody: ResolveBody
}

/**
 * ExperimentApiApi - object-oriented interface
 */
export class ExperimentApiApi extends BaseAPI {
    /**
     * 
     * @param {ExperimentApiApiExperimentApiAdminExperimentStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiAdminExperimentStats(requestParameters: ExperimentApiApiExperimentApiAdminExperimentStatsRequest, options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiAdminExperimentStats(requestParameters.experimentKey, requestParameters.days, requestParameters.introOffer, requestParameters.splitBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiAdminListExperiments(options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiAdminListExperiments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExperimentApiApiExperimentApiAdminSetDefaultIntroOfferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiAdminSetDefaultIntroOffer(requestParameters: ExperimentApiApiExperimentApiAdminSetDefaultIntroOfferRequest, options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiAdminSetDefaultIntroOffer(requestParameters.defaultIntroOfferBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExperimentApiApiExperimentApiAdminSetExperimentAllocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiAdminSetExperimentAllocation(requestParameters: ExperimentApiApiExperimentApiAdminSetExperimentAllocationRequest, options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiAdminSetExperimentAllocation(requestParameters.experimentKey, requestParameters.allocationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExperimentApiApiExperimentApiAdminSetExperimentStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiAdminSetExperimentStatus(requestParameters: ExperimentApiApiExperimentApiAdminSetExperimentStatusRequest, options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiAdminSetExperimentStatus(requestParameters.experimentKey, requestParameters.statusBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExperimentApiApiExperimentApiAdminSetExperimentWeightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiAdminSetExperimentWeights(requestParameters: ExperimentApiApiExperimentApiAdminSetExperimentWeightsRequest, options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiAdminSetExperimentWeights(requestParameters.experimentKey, requestParameters.weightsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExperimentApiApiExperimentApiAdminSetIntroDealPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiAdminSetIntroDealPrices(requestParameters: ExperimentApiApiExperimentApiAdminSetIntroDealPricesRequest, options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiAdminSetIntroDealPrices(requestParameters.introDealPricesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExperimentApiApiExperimentApiAdminSetIntroOffersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiAdminSetIntroOffers(requestParameters: ExperimentApiApiExperimentApiAdminSetIntroOffersRequest, options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiAdminSetIntroOffers(requestParameters.experimentKey, requestParameters.introOffersBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExperimentApiApiExperimentApiAdminSetKillSwitchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiAdminSetKillSwitch(requestParameters: ExperimentApiApiExperimentApiAdminSetKillSwitchRequest, options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiAdminSetKillSwitch(requestParameters.killSwitchBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExperimentApiApiExperimentApiAdminSetUserArmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiAdminSetUserArm(requestParameters: ExperimentApiApiExperimentApiAdminSetUserArmRequest, options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiAdminSetUserArm(requestParameters.experimentKey, requestParameters.userArmBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExperimentApiApiExperimentApiLogExposureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiLogExposure(requestParameters: ExperimentApiApiExperimentApiLogExposureRequest, options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiLogExposure(requestParameters.exposureBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExperimentApiApiExperimentApiLogFunnelEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiLogFunnelEvent(requestParameters: ExperimentApiApiExperimentApiLogFunnelEventRequest, options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiLogFunnelEvent(requestParameters.funnelEventBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiMyExperiments(options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiMyExperiments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExperimentApiApiExperimentApiResolveExperimentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public experimentApiResolveExperiments(requestParameters: ExperimentApiApiExperimentApiResolveExperimentsRequest, options?: RawAxiosRequestConfig) {
        return ExperimentApiApiFp(this.configuration).experimentApiResolveExperiments(requestParameters.resolveBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ExperimentApiAdminExperimentStatsDaysEnum = {
    NUMBER_1: 1,
    NUMBER_7: 7,
    NUMBER_14: 14,
    NUMBER_30: 30,
} as const;
export type ExperimentApiAdminExperimentStatsDaysEnum = typeof ExperimentApiAdminExperimentStatsDaysEnum[keyof typeof ExperimentApiAdminExperimentStatsDaysEnum];
export const ExperimentApiAdminExperimentStatsIntroOfferEnum = {
    FreeMonth: 'free_month',
    Free7d: 'free_7d',
    Free45d: 'free_45d',
    DealFirstMonth: 'deal_first_month',
    Deal2Months: 'deal_2_months',
    DealOneTime: 'deal_one_time',
    ChoiceFreeOr2Months: 'choice_free_or_2_months',
} as const;
export type ExperimentApiAdminExperimentStatsIntroOfferEnum = typeof ExperimentApiAdminExperimentStatsIntroOfferEnum[keyof typeof ExperimentApiAdminExperimentStatsIntroOfferEnum];
